import React, { FC } from 'react'
import { Typography, Grid, Button } from '@mui/material'
import { ReportTypeVisibilitySwitch } from './reportTypeVisibilitySwitch'

interface InlineReportTypeProps {
  id: number;
  name: string;
  description?: string
  isVisible: boolean
  onEdit: (id: number) => void;
}

export const InlineReportType: FC<InlineReportTypeProps> = (props) => {
  const { id, name, description, isVisible, onEdit } = props

  return (
    <>
      <Grid item xs={12} sm={8}>
        <Grid container flexDirection='column'>
          <Grid item xs={12}>
            <Typography>{name}</Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography variant="body2">{description || ''}</Typography>
          </Grid>
        </Grid>
      </Grid>
      <Grid container item xs={8} sm={3} justifyContent={{ xs: 'flex-start', sm: 'flex-end' }} alignItems="center" spacing={2}>
        <Grid item alignSelf="center">
          <Typography variant='body1'>Is active?</Typography>
        </Grid>
        <Grid item>
          <ReportTypeVisibilitySwitch
            name={name}
            reportTypeId={id as number}
            isVisible={isVisible}
          />
        </Grid>
      </Grid>
      <Grid container item xs={4} sm={1} justifyContent="flex-end" alignItems="center">
        <Button
          variant="contained"
          onClick={() => onEdit(id)}
        >
          Edit
        </Button>
      </Grid>
    </>
  )
}